import { ConstantsProject } from '@web/project/shared/constants.class';
import { getCookie } from '@web/base/shared/utils';
import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IVideo } from './video.model';
import { EmbedVideoService } from './embed-video-service';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { order } from '@web/shared/utils';
import { MatGridList } from '@angular/material/grid-list';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'web-videos-module',
  templateUrl: './videos-module.component.html',
  styleUrls: ['./videos-module.component.scss']
})
export class VideosModuleComponent implements OnInit {

  @ViewChild('videoGallery') videoGallery: ElementRef;
  public innerWidth: number;

  @Input() videos: IVideo[];
  @Input() title: string;
  @Input() classList: string;
  @Input() order: 'asc' | 'desc' = 'asc';

  private cookiesConsent;
  public functionalCookies = false;

  constructor(
    public dialog: MatDialog,
    private sanitizer: DomSanitizer,
    public embedVideoService: EmbedVideoService
  ) { }

  ngOnInit() {
    if (this.order === 'asc') {
      this.videos.sort((a, b) => order(a, b));
    } else {
      this.videos.sort((a, b) => order(a, b, 'order', 'desc'));
    }

    this.videos.map(async (v, i) => {
      this.embedVideoService.url_image(v.videoUrl)
        .then(thumbnail => {
          if (thumbnail) {
            this.videos[i].thumbnail = thumbnail;
          }
        });
    });

    // Comprobar cookies para mostrar ciertos contenidos
    this.cookiesConsent = JSON.parse(getCookie(ConstantsProject.COOKIES_CONSENT));
    if (this.cookiesConsent) {
      this.functionalCookies = this.cookiesConsent.functionals;
    }
  }

  loadVideo(video: IVideo) {
    if (this.functionalCookies) {
      this.dialog.open(VideoDialogComponent, {
        panelClass: ['dialog', 'dialog-sm', 'video-dialog'],
        data: {
          title: video.title,
          video: this.sanitizer.bypassSecurityTrustResourceUrl(this.embedVideoService.embed_video(video.videoUrl))
        },
        width: '75%'
      });
    }
  }

}
